import { render, staticRenderFns } from "./testSortQuestionsItem.vue?vue&type=template&id=206a7f00&"
import script from "./testSortQuestionsItem.vue?vue&type=script&lang=ts&"
export * from "./testSortQuestionsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports